module.exports = __webpack_public_path__ + "static/thief_wall-3c4618a324ebbbc60bd5f4ca1ec6c025.jpg";